import { render, staticRenderFns } from "./DeliveryView.vue?vue&type=template&id=46891a10&"
import script from "./DeliveryView.vue?vue&type=script&lang=js&"
export * from "./DeliveryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports